import script from "./OperationsBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsBoard.vue?vue&type=script&setup=true&lang=js"

import "./OperationsBoard.vue?vue&type=style&index=0&id=7d39b2ae&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d39b2ae"]])

export default __exports__